import React from 'react';
import {Box, useColorModeValue} from '@chakra-ui/react';

const BoxCard = props => {
  const breakpoints = props.breakpoints ? props.breakpoints : {base: 'column', md: 'row'};
  return (
    <Box
      boxShadow="lg"
      rounded="md"
      border="1px"
      borderColor="blackAlpha.200"
      p="3"
      mb="2"
      bg={useColorModeValue('tertiary.50', 'gray.700')}
      flexDir={breakpoints}
      {...props}
    >
      {props.children}
    </Box>
  );
};

export default BoxCard;
